<app-hzoom> 
  <div class="map-svg-container" #mapSvgContainerRef ></div> 
</app-hzoom>